import { Injectable } from '@angular/core';
import { HttpEvent, HttpHandler, HttpInterceptor, HttpRequest } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';

/**
 * Evita que o Angular Service Worker trate pedidos à API como assets (ex.: prefetch GET em endpoints só POST → 405).
 * Pedidos à mesma origem da apiUrl recebem o cabeçalho que o ngsw-worker ignora para cache/reescrita.
 */
@Injectable()
export class NgswBypassInterceptor implements HttpInterceptor {
  intercept(req: HttpRequest<unknown>, next: HttpHandler): Observable<HttpEvent<unknown>> {
    const base = (environment.apiUrl || '').replace(/\/+$/, '');
    if (!base || !(req.url.startsWith(base) || req.url.startsWith(`${base}/`))) {
      return next.handle(req);
    }

    return next.handle(req.clone({ setHeaders: { 'ngsw-bypass': 'true' } }));
  }
}
